import { CHANNELINFO_DETAILS, CHANNELINFO_LIST, CHANNELINFO_LIST_ERROR, CHANNELINFO_LIST_SUCCESS, CHANNELWIDTH_DETAILS, CHANNEL_CONVERTION_DETAILS, CHANNEL_MATRICS_DETAILS, DATA_SOURCE_LIST, DATA_SOURCE_LIST_ERROR, DATA_SOURCE_LIST_SUCCESS, GET_EVENT_RULES, GET_EVENT_RULES_DETAILS, GET_EVENT_RULES_ERROR, GET_EVENT_RULES_SUCCESS, GET_TERRAIN, GET_TERRAIN_ERROR, GET_TERRAIN_SUCCESS, MODEL_NAMES, MULTIPLEMODEL_LIST, MULTIPLEMODEL_LIST_ERROR, MULTIPLEMODEL_LIST_SUCCESS, UPDATE_EVENT_COMPARISON, UPDATE_EVENT_COMPARISON_ERROR, UPDATE_EVENT_COMPARISON_SUCCESS, UPDATE_IMG_CLASSIFICATION, UPDATE_IMG_CLASSIFICATION_ERROR, UPDATE_IMG_CLASSIFICATION_SUCCESS, UPDATE_SUBCHAINLIST, UPDATE_SUBCHAINLIST_ERROR, UPDATE_SUBCHAINLIST_SUCCESS } from './constants';

export default function channelInfoReducer(state, action) {
	const channelInfo = [];
	const multimod = [];
	switch (action.type) {
	case CHANNELINFO_LIST :
		return { ...state, pending: true };
	case CHANNELINFO_LIST_SUCCESS :
		action.payload && action.payload.map((item) => {
			channelInfo.push({
				id : item.id,
				name : item.name ? item.name : '-',
				binSize : item.binSize ? parseFloat(item.binSize).toFixed(4) : '-',
				startPos : item.startPos,
				amplitudeNumber : item.amplitudeNumber ? item.amplitudeNumber : '-',
				pidsinfoId : item.pidsinfo ? item.pidsinfo.name : '-',
				channelId : item.channelId ? item.channelId : '-',
				profile : item.profile ? item.profile : '-',
				regioninfoId : item.regioninfo ? item.regioninfo.regionName : '-',
				modelTypeOverride : item.modelTypeOverride || item.modelTypeOverride == false ? item.modelTypeOverride : '-',
				modelPredictionLevel : item.modelPredictionLevel ? item.modelPredictionLevel : '-',
				predictionDecisionThreshold : item.predictionDecisionThreshold || item.predictionDecisionThreshold == 0 ? item.predictionDecisionThreshold : 1,
				l1Model : item.l1Model ? item.l1Model : '-',
				l2ModelThreat : item.l2ModelThreat ? item.l2ModelThreat : '-',
				l2ModelNonthreat : item.l2ModelNonthreat ? item.l2ModelNonthreat : '-',
				l3ModelMachinedigging : item.l3ModelMachinedigging ? item.l3ModelMachinedigging : '-',
				l3ModelManualdigging : item.l3ModelManualdigging ? item.l3ModelManualdigging : '-',
				l3ModelVehiclemovement : item.l3ModelVehiclemovement ? item.l3ModelVehiclemovement : '-',
				overrideLowerLimit : item.overrideLowerLimit || item.overrideLowerLimit == 0 ? item.overrideLowerLimit : 0,
				overrideUpperLimit : item.overrideUpperLimit || item.overrideUpperLimit == 0 ? item.overrideUpperLimit : 3,
				predictedEventConfirmation : item.predictedEventConfirmation ? item.predictedEventConfirmation : '-',
				eventComparison: item.eventComparison,
				imgClassification : item.imgClassification,
				subchainEnabled : item.subchainEnabled ? item.subchainEnabled : null,
				datasourceId: item.datasourceId ? item.datasourceId : null
			});
		});
		return { ...state, channelInfo: channelInfo, pending: false };
	case CHANNELINFO_LIST_ERROR :
		return { ...state, error: true, pending: false };
	case CHANNELINFO_DETAILS :
		return { ...state,channelDetails : action.payload, error: true, pending: false };
	case CHANNELWIDTH_DETAILS :
		return { ...state, channelWidth : action.payload };
	case CHANNEL_CONVERTION_DETAILS :
		return { ...state, channelConvertion : action.payload };
	case CHANNEL_MATRICS_DETAILS :
		return { ...state, channelMatrics : action.payload };
	case MODEL_NAMES :
		return { ...state, modelNames : action.payload };

	case GET_TERRAIN : 
		return { ...state, loading: true, error: false };

	case GET_TERRAIN_SUCCESS:
		if (action.payload) {
			// pagination.total = action.payload.total ? action.payload.total : 0;
			// pagination.limit = action.payload.limit ? action.payload.limit : 10;
			// pagination.skip = action.payload.skip ? action.payload.skip : 0;
			// pagination.current = action.page ? action.page : 1;
		}
		return { ...state, terrains: action.payload, loading: false };

	case GET_TERRAIN_ERROR:
		return { ...state, loading: false, error: true };

	case GET_EVENT_RULES : 
		return { ...state, loading: true, error: false };

	case GET_EVENT_RULES_SUCCESS:

		return { ...state, eventrules: action.payload, loading: false };

	case GET_EVENT_RULES_ERROR:
		return { ...state, loading: false, error: true };
	
	case GET_EVENT_RULES_DETAILS :
		return { ...state, eventRluesDetails : action.payload };

	case UPDATE_EVENT_COMPARISON :
		return { ...state, loading: true  };

	case UPDATE_EVENT_COMPARISON_SUCCESS:

		return { ...state, loading: false };

	case UPDATE_EVENT_COMPARISON_ERROR:
		return { ...state, loading: false, error: true };

	case UPDATE_IMG_CLASSIFICATION:
		return { ...state, loading: true  };
	case UPDATE_IMG_CLASSIFICATION_SUCCESS:
		return { ...state, loading: false };
	case UPDATE_IMG_CLASSIFICATION_ERROR:
		return { ...state, loading: false, error: true };

	case MULTIPLEMODEL_LIST:
		return { ...state, pending: true };	  
	case MULTIPLEMODEL_LIST_SUCCESS:
			
		if (action.payload && action?.payload?.data?.length > 0) {
			action?.payload?.data?.map( (item) => {
				let data = {};
				data.id = item.id ? item.id : 0;
				data.modelclassname =  item &&  item?.modelclassifications?.alias ? item.modelclassifications?.alias : item.modelclassifications?.modelLevel ? item.modelclassifications?.modelLevel : '-';
				data.name = item && item?.name && item?.name ? item.name : '';
				data.isSubChain = item && item?.isSubChain && item?.isSubChain ? true : false;
				return multimod.push(data);
			});  
			return { ...state, multimod: multimod, pending: false, error: false };
		} else {
			if (action.payload && action.payload.data.length === 0) {
				return { ...state, multimod: [], pending: false, error: false };
			} else {
				return { ...state, pending: false, error: true };
			}
		}
  
	case MULTIPLEMODEL_LIST_ERROR:
		return { ...state, pending: false, error: true };
	
	case UPDATE_SUBCHAINLIST :
		return { ...state, loading: true  };

	case UPDATE_SUBCHAINLIST_SUCCESS:

		return { ...state, loading: false };

	case UPDATE_SUBCHAINLIST_ERROR:
		return { ...state, loading: false, error: true };
	case DATA_SOURCE_LIST:
		return {...state, loading : false , error : false};
	case DATA_SOURCE_LIST_SUCCESS:
		return { ...state, datasource:action.payload ,  loading: false, error: false };
	case DATA_SOURCE_LIST_ERROR:
		return {...state, loading : false , error : true};	

	default: {
		throw Error('Unknown action: ' + action.type);
	}
	}
}